var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { staticClass: "common" }, [
      _c("div", { staticClass: "services" }, [
        _c("p", [_vm._v("ＪリーグID利用サービスに戻る")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("a", { attrs: { href: "https://www.jleague-ticket.jp/" } }, [
              _c("img", {
                attrs: {
                  src: "https://auth2.jleague.jp/img/bnrTicket.png",
                  width: "216",
                  height: "98",
                  id: "bnrTicket",
                  alt: "",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "https://store.jleague.jp/" } }, [
              _c("img", {
                attrs: {
                  src: "https://auth2.jleague.jp/img/bnrStore.png",
                  width: "216",
                  height: "98",
                  id: "bnrStore",
                  alt: "",
                },
              }),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "subLinks" }, [
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://auth2.jleague.jp/contents/privacypolicy.html",
              },
            },
            [_vm._v("プライバシーポリシー")]
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://auth2.jleague.jp/contents/agreement.html",
              },
            },
            [_vm._v("利用規約")]
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://auth2.jleague.jp/contents/guide.html",
              },
            },
            [_vm._v("よくある質問・お問い合わせ")]
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://auth2.jleague.jp/contents/accessibility.html",
              },
            },
            [_vm._v("ウェブアクセシビリティについて")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "copyrights" }, [
        _vm._v(
          "\n        本サイトで使用している文章・画像等の無断での複製・転載を禁止します。"
        ),
        _c("br"),
        _vm._v(" "),
        _c("small", [
          _vm._v("©JAPAN PROFESSIONAL FOOTBALL LEAGUE ALL RIGHTS RESERVED."),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }